import styled from 'styled-components'

export const RerollContainer = styled.div`
  max-width: 1200px;
  min-width: 600px;
  padding: 0px 40px;
  min-height: 75vh;
  opacity: 80%;
  margin-top: 0px;
  background-color: #000;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #fff;
`

export const Heading = styled.h1`
  margin-bottom: 20px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #fff;
  text-align: center;
`

export const Subtitle = styled.p`
  color: #9df743;
  font-size: 16px;
  line-height: 16px;
  font-weight: 500;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 24px;
  text-align: center;
`

export const FormContainer = styled.div`

`

export const RerollForm = styled.form`
  display: flex;
  flex-direction: column;
`

export const RerollSelect = styled.select`
  width: 100%;
  opacity: 100%;
  padding-left: 5px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  height: 35px;
  background: #fff;
  color: #000;
  margin: 4px 0px 10px;
`

export const Label = styled.label`
  color: #fff;
  font-size: 16px;
  margin-top: 20px;
`

export const SelectOption = styled.option`
  color: #000;
  white-space: pre;
  font-size: 16px;
`

export const RerollSubmit = styled.input`
  border-radius: 20px;
  background: #9df743;
  white-space: nowrap;
  padding: 10px 20px;
  margin-top: 30px;
  color: #000;
  font-size: 20px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
  margin-bottom: 24px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #181818;
    color: #9df743;
  }
`

export const RerollAllButton = styled.button`
  border-radius: 20px;
  background: #9df743;
  white-space: nowrap;
  padding: 10px 20px;
  margin-top: 20px;
  color: #000;
  font-size: 20px;
  outline: none;
  cursor: pointer;
  display: flex;
  border: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #181818;
    color: #9df743;
  }
`

export const TextField = styled.h3`
  color: #fff;
`